import {Request} from '@/apis'

export function tree(params) {
    return Request.get("/menu/tree", params);
}

export function fullTree(params) {
    return Request.get("/menu/fullTree", params);
}

export function getObj(id) {
    return Request.get("/menu/" + id);
}

export function saveObj(obj) {
    return Request.post("/menu", obj);
}

export function updateObj(obj) {
    return Request.put("/menu", obj);
}

export function deleteObj(id) {
    return Request.delete("/menu/" + id);
}
